(function(){
    var ComparisonTableRow = function(element) {
        this.element = element;
        this.cols = [];
        this.row_data = {};
        this.num_to_show = 3;
        this.pageoffset = 1;
        

        this.init();
        this.setNumToShowFromWindowWidth();
        this.bindListeners();
        
        
        
        // 
    }


    ComparisonTableRow.prototype.init = function() {
        var cols = this.element.getElementsByClassName('js-comparison-table-col');
        this.row_data = this.element.querySelector('.js-comparison-table-row-data');
        
        // console.log(cols);
        for (var i=0; i<cols.length; i++) {
            this.cols.push(cols[i]);
        }
    }
    ComparisonTableRow.prototype.setActive = function() {
        this.row_data.innerHTML = '';
        for (var i = this.pageoffset; i < this.num_to_show; i++) {
            
        }
         for (var i = (this.pageoffset - 1) * this.num_to_show; i < (this.pageoffset * this.num_to_show); i++) {
            if (typeof this.cols[i] !== 'undefined') {
                this.row_data.append(this.cols[i]);
            }
            
        }
    }
    ComparisonTableRow.prototype.setNumToShowFromWindowWidth = function(num_to_show) {
        var window_width = window.outerWidth;
        this.pageoffset = 1;
        if (window_width < 512) {
           this.setNumToShow(2);
        }
        else if (window_width < 768) {
           this.setNumToShow(2);
        }
        else {
            this.setNumToShow(3)
        }
        // if (this.num_to_show === this.cols.length) {
        //     this.prevTrigger.addClass('hidden');
        //     this.nextTrigger.addClass('hidden');
        // }
        // alert(this.num_to_show)
    }
    ComparisonTableRow.prototype.setNumToShow = function (num_to_show) {
        this.num_to_show = num_to_show;
        this.setActive();
    }
    ComparisonTableRow.prototype.changePage = function(page) {
        this.pageoffset = page;
        this.setActive();
    }
    ComparisonTableRow.prototype.incrementPage = function() {
        if (this.pageoffset < this.numPages()) {
            this.changePage(this.pageoffset + 1);
        }
        
    }
    ComparisonTableRow.prototype.decrementPage = function() {
        if (this.pageoffset > 1) {
            this.changePage(this.pageoffset - 1);
        }
    }
    ComparisonTableRow.prototype.bindListeners = function() {
        var row = this;
        
       

        
    }
    ComparisonTableRow.prototype. numPages = function()
    {
        return Math.ceil(this.cols.length / this.num_to_show);
    }
    var ComparisonTable = function(element){
        this.element = element;
        this.rows = [];
        this.nextTrigger;
        this.prevTrigger;
        this.pager;
        this.showPager = true;
        this.disableNext = false;
        this.disablePrev = true;
        this.init(false);
        // console.log(this.rows);
    }
    ComparisonTable.prototype.init = function(options = {}) {
        if( typeof options.showPager !== 'undefined'){
            this.showPager = options.showPager;
        }
        
        var el_rows = this.element.getElementsByClassName('js-comparison-table-row');
        if(this.showPager) {
            this.pager = document.createElement('div');
            this.pager.classList.add('comparison-table__pager', 'padding-bottom-sm','padding-top-sm', 'flex', 'flex-wrap', 'justify-end', 'zindex-3');

            this.nextTrigger = document.createElement('button');
            this.nextTrigger.classList.add('js-comparison-table-next','btn','btn--secondary','btn--sm');
            this.nextTrigger.innerText = 'Next';


            
            // this.element.querySelector('');
            this.prevTrigger = document.createElement('button');
            
            this.prevTrigger.classList.add('js-comparison-table-prev','btn','btn--secondary','btn--sm', 'margin-right-xs');
            this.prevTrigger.innerText = 'Prev';
            this.pager.append(this.prevTrigger);
            this.pager.append(this.nextTrigger);

            this.element.prepend(this.pager);

        }
        
        
        for (var i=0; i<el_rows.length;i++) {
            this.rows.push(new ComparisonTableRow(el_rows[i]));
        }
        
        this.bindListeners();
        this.checkPager();
        this.togglePagerButtons();
        
    }
    ComparisonTable.prototype.togglePagerButtons = function() {
        if(this.disableNext) {
            this.nextTrigger.setAttribute('disabled', true);
        } else {
            this.nextTrigger.removeAttribute('disabled');
        }
        if(this.disablePrev) {
            this.prevTrigger.setAttribute('disabled', true);
        }else {
            this.prevTrigger.removeAttribute('disabled', true);
        }
    }
    ComparisonTable.prototype.showPrev = function() {
        var rows = this.rows;
        for(var i=0; i<rows.length; i++) {
            rows[i].decrementPage();
            this.checkRow(rows[i]);
            
        }
       
    }
    ComparisonTable.prototype.checkRow = function(row) {
        if(row.num_to_show === row.pageoffset) {
            this.disableNext = true;
        } else {
            this.disableNext = false;
        }
        if(row.pageoffset === 1) {
            this.disablePrev = true;
        } else {
            this.disablePrev = false;
        }
        this.togglePagerButtons();
    }
    ComparisonTable.prototype.showNext = function() {
        var rows = this.rows;
        for(var i=0; i<rows.length; i++) {
            rows[i].incrementPage();
            this.checkRow(rows[i]);
        }
    }
    ComparisonTable.prototype.bindListeners = function() {
        new SwipeContent(this.element);
        var table = this;
        if(this.showPager){
            this.prevTrigger.addEventListener('click', function(){
                table.showPrev();
                
            });
            this.nextTrigger.addEventListener('click', function(){
                table.showNext();
            });    
        }
        
        this.element.addEventListener('swipeLeft', function(event){
            table.showNext();
        });
        this.element.addEventListener('swipeRight', function(event){
            table.showPrev();
            
        });
        
        window.addEventListener('resize', function(){
            var timeout;
            if (timeout) {
                this.clearTimeout(timeout);
            }
            timeout = this.setTimeout(function () {
                table.checkPager();
                
                
            }, 400);
        });
    }
    ComparisonTable.prototype.checkPager = function() {
        var table = this;
        var pager = this.pager;
        for (var i = 0; i < table.rows.length; i++) {    
            table.rows[i].setNumToShowFromWindowWidth();
            
            if (table.rows[i].cols.length <= table.rows[i].num_to_show) {
                pager.classList.add( 'is-hidden' );
                this.element.classList.remove('has-pager');
            } else {
                pager.classList.remove( 'is-hidden' );
                this.element.classList.add('has-pager');
            }
        }
    }

    window.ComparisonTable = ComparisonTable;
    var comparison_table = document.getElementsByClassName('js-comparison-table');
    if( comparison_table.length > 0) {
        for( var i = 0; i < comparison_table.length; i++) {
            (function(i){ new ComparisonTable(comparison_table[i]);})(i);
        }
    }   

}());
